import React from "react";
import HomeIcon from "../common/HomeIcon";
import DownloadBtnCommon from "../common/DownloadBtn";
import Mantra_3_A1_Share from "../Mantra3/Mantra_3_A1_Share";
import SharePrintIcon from "../common/SharePrintIcon";
import { imgBaseUrl } from "../../utils/url";
import Mantra_3N_Edit from "./Mantra_3N_Edit";

class Mantra_3N extends React.Component {
  constructor() {
    super();
    this.state = {
      form: false,
      showCanvas: false,
      img: null,
      id: null,
      bckBttn: false,
    };
  }

  setForm = () => {
    this.setState({ form: true, bckBttn: true });
  };

  onCanVase = (img, id) => {
    this.setState({ showCanvas: true, form: false, img, id });
  };

  backToForm = () => {
    this.setState({ form: false, bckBttn: false });
  };
  render() {
    const { form, img, id, bckBttn } = this.state;
    const { pageData, module_name } = this.props;
    let image = pageData.template_url ? imgBaseUrl + pageData.template_url : "";
    let text = pageData.description ? pageData.description : "";
    return (
      <>
        <HomeIcon goToFormBack={bckBttn} backToForm={this.backToForm} />

        {form ? (
          <Mantra_3N_Edit {...this.props} onCanVase={this.onCanVase} />
        ) : (
          !this.state.showCanvas && (
            <div className="m3_a1_container">
              <SharePrintIcon
                pageData={this.props.pageData}
                image={image}
                text={text}
                id={module_name}
              />
              <div className="container">
                <div className="pos_rel">
                  <img src="/assets/img/mantra3n.jpg" className="m3a1_img" />
                </div>
                <div className="mantra_18_btns">
                  <button
                    className="btn_f"
                    onClick={() => {
                      this.setForm();
                    }}
                  >
                    Fill & Share
                  </button>
                  <h5 className="or">Or</h5>
                  <DownloadBtnCommon pageData={pageData} module={module_name}>
                    <button className="btn_f">Download</button>
                  </DownloadBtnCommon>
                </div>
              </div>
            </div>
          )
        )}

        {this.state.showCanvas && img && (
          <Mantra_3_A1_Share img={img} id={id} pageData={this.props.pageData} />
        )}
      </>
    );
  }
}

export default Mantra_3N;
